import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (payload) => {
  const res = await axios.post(`${API}/contact`, payload);
  return res.data;
};

export const joinWaitlist = async ({ email, source = "mise-at-home" }) => {
  const res = await axios.post(`${API}/waitlist`, { email, source });
  return res.data;
};

export const submitHohPilot = async (payload) => {
  const res = await axios.post(`${API}/hoh-pilot`, payload);
  return res.data;
};

export const submitHohDemo = async (payload) => {
  const res = await axios.post(`${API}/hoh-demo`, payload);
  return res.data;
};

export const submitFamilyMealsInquiry = async (payload) => {
  const res = await axios.post(`${API}/family-meals-inquiry`, payload);
  return res.data;
};

export const getImpactStats = async () => {
  const res = await axios.get(`${API}/impact-stats`);
  return res.data;
};

export const updateImpactStats = async (payload, adminToken) => {
  const res = await axios.put(`${API}/impact-stats`, payload, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

export const fetchAnalyticsDashboard = async (adminToken, start, end) => {
  const params = new URLSearchParams();
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  const res = await axios.get(`${API}/analytics/dashboard?${params}`, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

export const fetchAnalyticsToday = async (adminToken) => {
  const res = await axios.get(`${API}/analytics/today`, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

export const triggerAnalyticsAggregate = async (adminToken, date) => {
  const res = await axios.post(`${API}/analytics/aggregate?date=${date}`, null, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

export const fetchSubmissionCounts = async (adminToken) => {
  const res = await axios.get(`${API}/admin/submissions/counts`, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

// status is one of: new, contacted, in_progress, converted, closed
export const updateSubmissionStatus = async (adminToken, kind, id, status) => {
  const res = await axios.patch(`${API}/admin/submissions/${kind}/${id}`, { status }, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

export const deleteSubmission = async (adminToken, kind, id) => {
  const res = await axios.delete(`${API}/admin/submissions/${kind}/${id}`, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

// kind is one of: contact, waitlist, hoh-pilot, hoh-demo, family-meals-inquiry
export const fetchSubmissions = async (adminToken, kind) => {
  const res = await axios.get(`${API}/${kind}?limit=500`, {
    headers: { "X-Admin-Token": adminToken },
  });
  return res.data;
};

// ---------- Media page ----------
export const fetchMedia = async () => {
  const res = await axios.get(`${API}/media`);
  return res.data;
};

export const fetchAdminMedia = async (adminToken) => {
  const res = await axios.get(`${API}/admin/media`, { headers: { "X-Admin-Token": adminToken } });
  return res.data;
};

export const createMediaItem = async (adminToken, payload) => {
  const res = await axios.post(`${API}/admin/media`, payload, { headers: { "X-Admin-Token": adminToken } });
  return res.data;
};

export const updateMediaItem = async (adminToken, id, payload) => {
  const res = await axios.put(`${API}/admin/media/${id}`, payload, { headers: { "X-Admin-Token": adminToken } });
  return res.data;
};

export const deleteMediaItem = async (adminToken, id) => {
  const res = await axios.delete(`${API}/admin/media/${id}`, { headers: { "X-Admin-Token": adminToken } });
  return res.data;
};
